<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="#2A3243"/>
<circle cx="24" cy="24" r="20" fill="#2A3243"/>
<path d="M34 23.9993H14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.999 13.9995V33.9995" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
